export default {"src":"/login-app/[GIT_HASH]/_next/static/media/bug.30cc1bf9.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};